import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-unapplied-money",
  "use": "fi-icon-custom-unapplied-money-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fi-icon-custom-unapplied-money\">\n<path d=\"M26 14C26 20.628 20.628 26 14 26C12.136 26 10.372 25.576 8.798 24.818L4.938 25.946C4.496 26.076 4.07 25.698 4.148 25.242L4.754 21.65C3.034 19.574 2 16.908 2 14C2 7.372 7.372 2 14 2C20.628 2 26 7.372 26 14Z\" stroke=\"white\" stroke-width=\"2.5\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol